type PresignedUrlResponse = {
  presignedUrl: string
  s3Uri: string
  s3HttpUrl: string
}

import { getConfig } from '@/config/runtime'

export async function getPresignedUrl(file: File): Promise<PresignedUrlResponse> {
  try {
    const response = await fetch(`${getConfig().plus.apiUrl}/upload-url`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filename: `${file.name}`,
      }),
    })

    if (!response.ok) {
      throw new Error('Error fetching presigned URL')
    }

    return await response.json()
  } catch (error) {
    console.error('Error fetching presigned URL:', error)
    throw error
  }
}

export async function uploadFileWithProgress(
  file: File,
  presigned: PresignedUrlResponse,
  onProgress: (percentage: number) => void
): Promise<string> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', presigned.presignedUrl, true)

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentage = Math.round((event.loaded * 100) / event.total)
        onProgress(percentage)
      }
    }

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(presigned.s3Uri)
      } else {
        reject(new Error('Upload failed'))
      }
    }

    xhr.onerror = () => {
      reject(new Error('Network error'))
    }

    xhr.send(file)
  })
}
